import {
    INVOICE_BACKGROUND_PRESETS,
    INVOICE_TEXT_COLOR_PRESETS,
    normalizeHexColor,
} from "@common/constants/invoiceDesign";

export const DEFAULT_CUSTOM_BACKGROUND = "#ffffff";

export function isPresetSelected(
    backgroundColor: string | null,
    presetBackground: string,
): boolean {
    return (
        backgroundColor != null &&
        normalizeHexColor(backgroundColor) === presetBackground
    );
}

export function isCustomBackgroundColor(
    backgroundColor: string | null,
): boolean {
    return (
        backgroundColor != null &&
        !INVOICE_BACKGROUND_PRESETS.some((preset) =>
            isPresetSelected(backgroundColor, preset.background),
        )
    );
}

// Same custom-tile rule as isCustomBackgroundColor, against the Font color
// presets (which include the flat default as their first entry — see
// INVOICE_TEXT_COLOR_PRESETS) instead of the Background presets.
export function isCustomTextColor(textColor: string | null): boolean {
    return (
        textColor != null &&
        !INVOICE_TEXT_COLOR_PRESETS.some((preset) =>
            isPresetSelected(textColor, preset.color),
        )
    );
}
